import React from "react";

export default function HSLCAchievement(){
    return (
        <>
        <img className="mx-auto my-6 w-5/6" src="/assets/images/HSLC2024.jpg" alt="HSLC 2024 Result"/>
        </>
    );
}